/**
 * Contact portal analytics.
 *
 * Sends once the server has accepted the submission.
 */

type DataLayerWindow = Window & { dataLayer?: Record<string, unknown>[] };

export interface FormSubmitSuccessEvent {
  formId: string;
  formCategory?: string;
  formTopic?: string;
}

export function pushFormSubmitSuccess({
  formId,
  formCategory,
  formTopic,
}: FormSubmitSuccessEvent): void {
  if (typeof window === 'undefined') {
    return;
  }
  const w = window as DataLayerWindow;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({
    event: 'form_submit_success',
    form_id: formId,
    form_category: formCategory ?? '',
    form_topic: formTopic ?? '',
  });
}
